var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.value.data),function(subItem){return _c('div',{key:subItem,staticClass:"second-text"},[_c('span',{staticClass:"badge font-size-sm my-1 py-2 px-4 status-picked w-100"},[_vm._v(" "+_vm._s(subItem)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }